import { getToken } from 'data/auth/utils'
import { createApiHandler, CreateApiHandlerConfig } from 'services-next/api'
import { getUrlWithPathParams } from 'services/api'
import { parsePaginationOptions } from 'utils-next/api'
import { PaginationOptions } from 'utils-next/types'

import { SearchEngineCompany, SearchEngineQueryData, SearchPoolCompanyQueryResult } from '../../SearchEngine.types'

const SEARCH_ENGINE_ENDPOINT_PATH = 'admin/pool/companies'

export function getApiSearchEngineHandlers(config: Omit<CreateApiHandlerConfig, 'baseUrl'> = {}) {
  const token = getToken() || undefined
  const { callApi, downloadFile } = createApiHandler(token, config)

  async function apiGetSearchEngineCompanies(
    searchEngineData: SearchEngineQueryData,
    paginationOptions: PaginationOptions
  ): Promise<SearchEngineCompany[]> {
    const response = await callApi<SearchEngineCompany[] | SearchPoolCompanyQueryResult>({
      timeout: 30 * 60 * 1000,
      url: SEARCH_ENGINE_ENDPOINT_PATH,
      params: { ...parsePaginationOptions(paginationOptions), ...searchEngineData },
    })

    if (Array.isArray(response)) {
      return response as SearchEngineCompany[]
    } else {
      // eslint-disable-next-line no-console
      console.warn('Pool query executed')
      // eslint-disable-next-line no-console
      console.warn(`Query exec time: ${response.queryExecTime}`)
      // eslint-disable-next-line no-console
      console.warn(`Total results number: ${response.resultsNumber}`)
      // eslint-disable-next-line no-console
      console.warn(`Algorithm used: ${response.algorithm}`)
      if (response.query) {
        // eslint-disable-next-line no-console
        console.warn(`Query: ${JSON.stringify(response.query)}`)
      }
      if (response.error) {
        // eslint-disable-next-line no-console
        console.error(`Error: ${JSON.stringify(response.error)}`)
      }

      return response.results as SearchEngineCompany[]
    }
  }

  async function apiGetSearchEnginePoolCompanies(
    searchEngineData: SearchEngineQueryData,
    paginationOptions: PaginationOptions
  ): Promise<SearchPoolCompanyQueryResult> {
    return callApi<SearchPoolCompanyQueryResult>({
      timeout: 30 * 60 * 1000,
      url: SEARCH_ENGINE_ENDPOINT_PATH,
      params: { ...parsePaginationOptions(paginationOptions), ...searchEngineData },
    })
  }

  async function apiGetSearchEngineCompaniesCsv(searchEngineData: SearchEngineQueryData) {
    return downloadFile<string>(`SearchEngine-[${searchEngineData.keywords}].csv`, {
      url: getUrlWithPathParams(SEARCH_ENGINE_ENDPOINT_PATH, 'csv'),
      params: { ...searchEngineData },
    })
  }

  return {
    apiGetSearchEngineCompanies,
    apiGetSearchEnginePoolCompanies,
    apiGetSearchEngineCompaniesCsv,
  }
}
